import { render, staticRenderFns } from "./AddOrEditDialog.vue?vue&type=template&id=07de4dcb&scoped=true"
import script from "./AddOrEditDialog.vue?vue&type=script&lang=js"
export * from "./AddOrEditDialog.vue?vue&type=script&lang=js"
import style0 from "./AddOrEditDialog.vue?vue&type=style&index=0&id=07de4dcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07de4dcb",
  null
  
)

export default component.exports